// eslint-disable-next-line import/prefer-default-export
export const USAGE_HISTORY_URL = `https://api.tizeti.com/api/v1/legacy/getCustomerUsage`;
// 'https://tizeti.com/williams_rd/geniatechapi/index.php';
